/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { Component, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';

import { NbAuthService } from '@nebular/auth';
import { takeWhile } from 'rxjs/operators';

@Component({
  selector: 'ngx-auth',
  styleUrls: ['./auth.component.scss'],
  template: `
    <nb-layout>
      <nb-layout-column style="padding: 0; margin: auto;">
            <nb-auth-block style="width: 100vw; max-width: 100vw; padding: 0;">
              <router-outlet></router-outlet>
            </nb-auth-block>
      </nb-layout-column>
    </nb-layout>
  `,
})
export class NgxAuthComponent implements OnDestroy {

  private alive = true;

  subscription: any;

  authenticated: boolean = false;
  token: string = '';

  constructor(protected auth: NbAuthService, protected location: Location) {
    this.subscription = auth.onAuthenticationChange()
    .pipe(takeWhile(() => this.alive))
    .subscribe((authenticated: boolean) => {
      this.authenticated = authenticated;
    });
  }

  back() {
    this.location.back();
    return false;
  }

  ngOnDestroy(): void {
    this.alive = false;
  }
}
